<script>
	import { Router } from 'svelte-router-spa'
	import Timeline from './components/Timeline.svelte';
	import Form from './components/Form.svelte';
	import { ORIGINPATH, URL_APPEND } from '@general/constants'

	import { routes } from './routes/routes';

</script>

<!-- {JSON.stringify(routes)} -->
<!-- <Router {routes}  /> -->
<Router {routes} options={{ prefix: 'highlights' }}  />